var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockStop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1024 254.5c-424.9 0-769.3 344.4-769.3 769.3S599.1 1793 1024 1793s769.3-344.4 769.3-769.3-344.4-769.2-769.3-769.2m0 1371c-332.3 0-601.7-269.4-601.7-601.7S691.7 422 1024 422s601.7 269.4 601.7 601.7-269.4 601.8-601.7 601.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1063 584.9H947v558.8h411.4v-116H1063zM511.1 59.4H1536v120H511.1z"
})));
export default SvgClockStop;